// Global
import React from 'react';

// Local
import { Themes } from 'lib/themes';
import { BrandAndThemeProvider } from 'components/helpers/ContextProvider/BrandAndThemeContext';
import { CtaFields, HeadlineFields } from 'lib/types/headlineFields';
import { Preamble, PreambleOrientation } from 'components/helpers/Molecules/Preamble/Preamble';
import styles from './FeatureTextOnly.module.scss';

export interface FeatureTextOnlyProps extends HeadlineFields, CtaFields {
  theme?: Themes;
  preambleOrientation?: PreambleOrientation;
}

export const FeatureTextOnly = (props: FeatureTextOnlyProps) => {
  /*
   * Rendering
   */

  return (
    <BrandAndThemeProvider
      theme={props.theme}
      id="feature-text-only"
      data-component="authorable/shared/content/feature-text-only/feature-text-only"
      className={styles.featureTextOnly}
    >
      <div className={styles.featureTextOnlyCopy}>
        <Preamble {...props} align={props.preambleOrientation} />
      </div>
    </BrandAndThemeProvider>
  );
};
